// Application constants

export const SPECIAL_CATEGORIES = {
  ALL_PRODUCTS_EN: 'All products',
  ALL_PRODUCTS_AR: 'جميع المنتجات',
  OTHERS_EN: 'Others',
  OTHERS_AR: 'أخرى',
};

export const ROUTES = {
  // Admin routes
  ADMIN_SIGN_IN: '/admin/sign-in',
  ADMIN_CATEGORIES: '/admin/categories',
  ADMIN_PRODUCT_DETAILS: '/admin/products/:id',
  ADMIN_ADD_PRODUCT: '/admin/products/add/:categoryId',
  ADMIN_EDIT_PRODUCT: '/admin/products/edit/:productId',
  ADMIN_DASHBOARD: '/admin/dashboard',

  // User routes
  HOME: '/',
  PRODUCTS: '/products',
  PRODUCT_DETAILS: '/products/:id',
  CART: '/cart',
  CHECKOUT: '/checkout',
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken',
  LANGUAGE: 'i18nextLng',
  CART_ITEMS: 'cartItems',
};
